import PropTypes from 'prop-types';
import styled from 'styled-components';

import CategoryList from './CategoryList/CategoryList';

const TryAgainLabel = styled.div`
  margin-top: 5px; 
  font-size: 18px;
  font-weight: bold;
`;

const List = styled.ul`
  padding-left: 20px;
  margin-top: 5px;
  margin-bottom: 15px;
`;

const ListElementLabel = styled.li`
  font-size: 18px;
`;

const CategoryListHeaderLabel = styled.div`
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: bold;
`;


const NoSearchResultsFoundBlock = ({
  categories, categoriesPerRow, tryAgainLabel,
  firstListItemLabel, secondListItemLabel, categoryListHeaderLabel
}) => (
  <>
    <TryAgainLabel>{tryAgainLabel}</TryAgainLabel>
    <List>
      <ListElementLabel>{firstListItemLabel}</ListElementLabel>
      <ListElementLabel>{secondListItemLabel}</ListElementLabel>
    </List>

    <CategoryListHeaderLabel>{categoryListHeaderLabel}</CategoryListHeaderLabel>
    <CategoryList categories={categories} categoriesPerRow={categoriesPerRow} />
  </>

);


NoSearchResultsFoundBlock.propTypes = {
  tryAgainLabel: PropTypes.string.isRequired,
  firstListItemLabel: PropTypes.string.isRequired,
  secondListItemLabel: PropTypes.string.isRequired,
  categoryListHeaderLabel: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  categoriesPerRow: PropTypes.oneOf([3, 5, 10]).isRequired
};

export default NoSearchResultsFoundBlock;
